import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IChoosenFilterInterface } from 'app/library/all-users/interfaces/choosen-filter.interface';
import { AllUsersApiService } from 'app/library/all-users/services/all-users.api-service';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { takeUntil } from 'rxjs/operators';

interface UserStatus {
    id: string;
    translationKey: string;
    selected: boolean;
}

@Component({
    selector: 'app-status-filter',
    templateUrl: './status-filter.component.html',
    styleUrls: ['./status-filter.component.scss'],
})
export class StatusFilterComponent extends UnsubscribeOnDestroy implements OnInit {
    @Output()
    addedToList = new EventEmitter<IChoosenFilterInterface[]>();

    dataSource: UserStatus[];
    displayedColumns = ['name', 'buttons'];

    list: IChoosenFilterInterface[] = [];
    statuses: UserStatus[] = [
        {
            id: 'active',
            translationKey: 'USER.STATUS.ACTIVE',
            selected: false,
        },
        {
            id: 'inactive',
            translationKey: 'USER.STATUS.INACTIVE',
            selected: false,
        },
    ];

    constructor(private _allUsersService: AllUsersApiService, private _translateService: TranslateService) {
        super();

        this.dataSource = this.statuses;
    }

    ngOnInit(): void {
        this._allUsersService.filtersList$.pipe(takeUntil(this._unsubscribeAll)).subscribe((filters) => {
            this.list = filters;
            this.updateDataSource();
        });
    }

    updateDataSource(): void {
        this.dataSource = this.statuses.map((status) => ({
            ...status,
            selected: this.list.some((item) => item.entity.id === status.id && item.entity.type === 'Status'),
        }));
    }

    addToList(status: UserStatus): void {
        this.addedToList.emit([
            ...this.list,
            {
                entity: { id: status.id, type: 'Status' },
                valueToShow: `${this._translateService.instant('GENERAL.PROPERTY.STATUS')}: ${this._translateService.instant(status.translationKey)}`,
            },
        ]);
    }

    removeFromList(status: UserStatus): void {
        this.addedToList.emit(this.list.filter((item) => !(item.entity.id === status.id && item.entity.type === 'Status')));
    }
}
